




















































import {Component, Mixins} from 'vue-mixin-decorator';
import {Prop, Watch} from 'vue-property-decorator';
import {Inject} from 'inversify-props';

import FileSaver from 'file-saver';

import {CertificateDetails} from '@/model/system/certificate/certificateDetails';

import {ISystemCertificateService} from '@/services/system/ICertificate.service';
import CertificateDetailsComponent from '@/components/Utils/CertificateDetails.vue';

import {Certificate} from '@fidm/x509';
import {Notify} from '@/utils/Notify';


import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {CertificateDetailsComponent},
})
export default class CertificateInformation extends Mixins<BaseComponent>(BaseComponent) {
  @Prop({default: null})
  private certificateDetails!: CertificateDetails | null;

  @Inject(Symbol.for('ISystemCertificateService'))
  private certificateService!: ISystemCertificateService;

  private certificate: Certificate | null = null;

  private clipboardShow = false;
  private clipboardTitle = '';
  private clipboardContent = '';

  @Watch('certificateDetails')
  private updateCertificate() {
    if (this.certificateDetails) {
      this.certificate = Certificate.fromPEM(Buffer.from(this.certificateDetails.Content, 'utf8'));
    }
  }

  private async download() {
    if (!this.certificateDetails) {
      return;
    }

    const blob = new Blob([this.certificateDetails.Content], {type: 'text/plain;charset=utf-8'});
    FileSaver.saveAs(blob, 'certificate.crt');

  }

  private async copy(text: string) {
    try {
      await navigator.clipboard.writeText(text);
      Notify.Info(this.logger, 'The text has been copied to your clipboard');
    } catch (error) {
      this.clipboardContent = text;
      this.clipboardShow = true;
    }
  }
}
